module.exports = __webpack_public_path__ + "static/media/icons-ic-follow-up-demo-missed.3fcbb6c1.svg";